import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CurrencyFormat } from '../../../../Helpers/Formatters';
import { Row, Col } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
    blueText: {
        color: theme.palette.primary.main,
    },
}));


export default function NeedAnalysisResult(props) {
    const classes = useStyles();

    return (
        <React.Fragment>
            <TableContainer className='mb-3'>
                <Table className="mb-0">
                    <TableBody><TableRow className={`${classes.blueText} active`}>
                        <th colspan="2"><h5 className='ml-3 mt-2'>Needs</h5></th>
                    </TableRow>
                        <TableRow>
                            <TableCell>
                                Immediate Needs
                            </TableCell>
                            <TableCell className="text-right">
                                <span id="immediateNeeds"><CurrencyFormat number={props.finalNeed.immediateNeeds} whole /></span>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Long-Term Needs
                            </TableCell>
                            <TableCell className="text-right">
                                <span id="longTermNeeds"><CurrencyFormat number={props.finalNeed.longTermNeeds} whole /></span>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <strong>Total Needs</strong>
                            </TableCell>
                            <TableCell className="text-right">
                                <strong><span id="totalNeeds"><CurrencyFormat number={props.finalNeed.totalNeeds} whole /></span></strong>
                            </TableCell>
                        </TableRow>
                        <TableRow className={`${classes.blueText} active`}>
                            <th colspan="2"><h5 className='ml-3 mt-2'>Resources</h5></th>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Savings
                            </TableCell>
                            <TableCell className="text-right">
                                <span id="savings"><CurrencyFormat number={props.finalNeed.savings} whole /></span>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Existing Insurance
                            </TableCell>
                            <TableCell className="text-right">
                                <span id="existingInsurance"><CurrencyFormat number={props.finalNeed.existingInsurance} whole /></span>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Spouse's Earnings
                            </TableCell>
                            <TableCell className="text-right">
                                <span id="spouseEarnings"><CurrencyFormat number={props.finalNeed.spouseEarnings} whole /></span>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <strong>Total Resources</strong>
                            </TableCell>
                            <TableCell className="text-right">
                                <strong><span id="totalResources"><CurrencyFormat number={props.finalNeed.totalResources} whole /></span></strong>
                            </TableCell>
                        </TableRow>
                        <TableRow className={`${classes.blueText} active`}>
                            <th colspan="2"><h5 className='ml-3 mt-2'>Results</h5></th>
                        </TableRow>
                    </TableBody></Table>
            </TableContainer>
            <Row className='pb-5 px-3'>
                <Col md={8} className="text-left"><h4 className={classes.blueText}><strong>Additional Life Insurance Needed</strong></h4></Col>
                <Col md={4} className="text-right"><h4 className={classes.blueText}><strong><span id="finalResult"><CurrencyFormat number={props.finalNeed.finalResult} whole /></span></strong></h4></Col>
            </Row>
           <div className='button-hide'> <Button variant='contained' color='primary' onClick={() => props.onApply(props.finalNeed.finalResult)} className='top-class text-capitalize mt-5' >Apply This Amount</Button></div>
            <Row className='mt-5 pt-1'>* Assuming investable assets earn interest at a rate of 3% annually.</Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/CoverageAmountPopUp/NeedAnalysisResult.js